module.exports = __webpack_public_path__ + "media/images/pc/plans/reason_01_before@3x-6dde32b438c074af41e29e4bbba3fdfa.webp";